export default __webpack_public_path__ + "static/media/logo-24px-efefef.719efb40.svg";